import { useContext } from "react";
// import { FormContextMA } from "../form-context";
import {
  cardiacMedEnum,
  otherPresEnum,
} from "../../patient/clinical-services/service-steps/clinical-assessment/data";
import { irritantRhinitisEnum } from "../../patient/clinical-services/service-steps/differential/data";
import {
  chronicRhinosinusitisSymptomsEnum,
  infectiveRhinitisDurationEnum,
  infectiveRhinitisSymptomsEnum,
} from "../../patient/clinical-services/service-steps/signs-and-symptoms/data";
import {
  Section,
  Divider,
  H2,
  H3,
  P,
  CheckInput,
  DataField,
  TealSubSection,
} from "./common-components";
import { GetAlertConfirmation } from "../../../helpers/constant";
import { AllergicRhinitisDocTypes } from "../../patient/clinical-services/service-steps/documentation/data";

export const MedicalHistorySection = ({endService = null, formType, clinicalAssessment, signsAndSymptoms, differentialAssessment}) => {
  // const {
  //   formType,
  //   clinicalAssessment,
  //   signsAndSymptoms,
  //   differentialAssessment,
  // } = useContext(FormContextMA);

  return (
    <Section className="space-y-1" formType = {formType}>
      <H2>Medical History - Reasons for Referral</H2>
      <div className="space-y-4">
        <div className="space-y-2">
          <H3>Red Flag Medical Conditions</H3>
          <H3>Acute Medical Conditions</H3>
          <div className="space-y-4">
            <CheckInput
              checked={clinicalAssessment?.acuteMedicalConditions?.includes(
                "otitis media"
              )}
              label={
                // TODO: text for sub-label?
                <>
                  Otitis Media
                  {clinicalAssessment?.acuteMedicalConditions?.includes(
                    "otitis media"
                  ) ? (
                    <>
                      <br />
                      Override Reason: Conditions Remains in Chart; Not Part of
                      Assessment; Sub-Optiomal Condition
                    </>
                  ) : (
                    ""
                  )}
                </>
              }
            />
            <CheckInput
              checked={clinicalAssessment?.acuteMedicalConditions?.includes(
                "sinusitis"
              )}
              label="Chronic Recurrent Sinusitis"
            />
            <CheckInput
              checked={clinicalAssessment?.acuteMedicalConditions?.includes(
                "None"
              )}
              label="None"
            />
          </div>
        </div>
        <div className="space-y-2">
          <H3>Chronic Medical Conditons </H3>
          <div className="space-y-4">
            <CheckInput
              checked={clinicalAssessment?.chronicMedicalConditions?.find(
                (v) => v.medicalConditionName === "hypothyroidism"
              )}
              label={
                <>
                  Hypothyroidism
                  {clinicalAssessment?.chronicMedicalConditions?.find(
                    (v) =>
                      v.medicalConditionName === "hypothyroidism" &&
                      !v.symptomControlIndicator
                  ) ? (
                    <>
                      <br />
                      Symptom not controlled
                    </>
                  ) : (
                    ""
                  )}
                </>
              }
            />
            <CheckInput
              checked={clinicalAssessment?.chronicMedicalConditions?.find(
                (v) => v.medicalConditionName === "asthma"
              )}
              label={
                <>
                  Asthma
                  {clinicalAssessment?.chronicMedicalConditions?.find(
                    (v) =>
                      v.medicalConditionName === "asthma" &&
                      !v.symptomControlIndicator
                  ) ? (
                    <>
                      <br />
                      Symptom not controlled
                    </>
                  ) : (
                    ""
                  )}
                </>
              }
            />
            <CheckInput
              checked={
                clinicalAssessment?.chronicMedicalConditions?.length === 0
              }
              label="None"
            />
          </div>
          {clinicalAssessment?.redFlagConfirmationType !== 0 && (
            <TealSubSection className="space-y-[0.0416667in]">
              {/* TODO: data for values? */}
              <DataField
                label="Referral Reason"
                value={"Red Flag Medical Conditions"}
              />
              <DataField
                label="Referral Type"
                value={GetAlertConfirmation(
                  clinicalAssessment?.redFlagConfirmationType
                )}
              />
              {(clinicalAssessment?.redFlagConfirmationType === 1 ||
                clinicalAssessment?.redFlagConfirmationType === 2) && (
                <DataField
                  label="Explanation"
                  value={clinicalAssessment?.redFlagExplaination}
                />
              )}
              <DataField
                label={`Pharmacist Clinical Decision to ${
                  clinicalAssessment?.redFlagConfirmationType === 4
                    ? "End Service"
                    : "Continue with Service"
                }`}
                value={""}
              />
            </TealSubSection>
          )}
          <Divider />
        </div>

        {!endService?.endServiceObj?.redFlagEndService && (
          <div className="space-y-2">
            <H3>Drug Induced Allergic Rhinitis</H3>
            <DataField
              label="Prescription Medications Started in the Last 3 Months"
              value=""
            />
            <div className="space-y-4">
              <CheckInput
                checked={
                  !!clinicalAssessment?.cardiacMedications?.length &&
                  !clinicalAssessment?.cardiacMedications?.includes("None")
                }
                label={
                  <>
                    Cardiac
                    {!!clinicalAssessment?.cardiacMedications?.length &&
                    !clinicalAssessment?.cardiacMedications?.includes(
                      "None"
                    ) ? (
                      <>
                        <br />
                        {clinicalAssessment.cardiacMedications
                          .map?.(
                            (v) =>
                              cardiacMedEnum.options.find((o) => o.value === v)
                                ?.header
                          )
                          .join?.(", ") || ""}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
              <CheckInput
                checked={
                  !!clinicalAssessment?.otherPrescriptionMedications?.length &&
                  !clinicalAssessment?.otherPrescriptionMedications?.includes(
                    "None"
                  )
                }
                label={
                  <>
                    Other Prescription Medications
                    {!!clinicalAssessment?.otherPrescriptionMedications
                      ?.length &&
                    !clinicalAssessment?.otherPrescriptionMedications?.includes(
                      "None"
                    ) ? (
                      <>
                        <br />
                        {clinicalAssessment.otherPrescriptionMedications
                          .map?.(
                            (v) =>
                              otherPresEnum.options.find((o) => o.value === v)
                                ?.header
                          )
                          .join?.(", ") || ""}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
              <CheckInput
                checked={clinicalAssessment?.oralContraceptives === "Yes"}
                label={<>Oral Contraceptives</>}
              />
              <CheckInput
                checked={
                  (!clinicalAssessment?.cardiacMedications?.length ||
                    !!clinicalAssessment?.cardiacMedications?.includes(
                      "None"
                    )) &&
                  (!clinicalAssessment?.otherPrescriptionMedications?.length ||
                    !!clinicalAssessment?.otherPrescriptionMedications?.includes(
                      "None"
                    )) &&
                  (!clinicalAssessment?.otherPrescriptionMedications?.length ||
                    !!clinicalAssessment?.otherPrescriptionMedications?.includes(
                      "None"
                    )) &&
                  clinicalAssessment?.oralContraceptives !== "Yes"
                }
                label="None"
              />
              <Divider />
              <DataField
                vertical
                label="Non-Prescription Medications Started in the Last 3 Months"
                value={
                  !!clinicalAssessment?.nonPrescriptionMedications?.length &&
                  !clinicalAssessment.nonPrescriptionMedications.includes(
                    "None"
                  ) ? (
                    <P className="mt-[0.057083in]">
                      {clinicalAssessment.nonPrescriptionMedications.join?.(
                        ", "
                      )}
                    </P>
                  ) : (
                    "None"
                  )
                }
              />
            </div>
            {clinicalAssessment?.drugInducedConfirmationType !== 0 && (
              <TealSubSection className="space-y-[0.0416667in]">
                {/* TODO: data for values? */}
                <DataField
                  label="Referral Reason"
                  value={"Drug Induced Allergic Rhinitis"}
                />
                <DataField
                  label="Referral Type"
                  value={GetAlertConfirmation(
                    clinicalAssessment?.drugInducedConfirmationType
                  )}
                />
                {(clinicalAssessment?.drugInducedConfirmationType === 1 ||
                  clinicalAssessment?.drugInducedConfirmationType === 2) && (
                  <DataField
                    label="Explanation"
                    value={clinicalAssessment?.drugInducedExplaination}
                  />
                )}
                <DataField
                  label={`Pharmacist Clinical Decision to ${
                    clinicalAssessment?.drugInducedConfirmationType === 4
                      ? "End Service"
                      : "Continue with Service"
                  }`}
                  value={""}
                />
              </TealSubSection>
            )}
            <Divider />
          </div>
        )}

        {!endService?.endServiceObj?.allergensEndService && (
          <div className="space-y-2">
            <H3>Infective Rhinitis</H3>
            <div className="space-y-4">
              <CheckInput
                checked={
                  (!signsAndSymptoms?.infectiveRhinosinusitisSymptoms?.length ||
                    !!signsAndSymptoms?.infectiveRhinosinusitisSymptoms?.includes?.(
                      "none"
                    )) &&
                  (!signsAndSymptoms?.chronicRhinosinusitisSymptoms?.length ||
                    !!signsAndSymptoms?.chronicRhinosinusitisSymptoms?.includes?.(
                      "none"
                    ))
                }
                label={
                  <>
                    Duration of Symptoms: Less than 7 days - No Infective
                    Rhinitis Identified
                  </>
                }
              />
              <CheckInput
                checked={
                  !!signsAndSymptoms?.infectiveRhinosinusitisSymptoms?.length &&
                  !signsAndSymptoms?.infectiveRhinosinusitisSymptoms?.includes?.(
                    "none"
                  )
                }
                label={
                  <>
                    Duration of Symptoms: 7 to 10 days - Infective
                    Rhinosinusitis
                    {signsAndSymptoms?.infectiveRhinosinusitisSymptoms
                      ?.length ? (
                      <>
                        <br />
                        {signsAndSymptoms.infectiveRhinosinusitisSymptoms
                          .map?.(
                            (v) =>
                              infectiveRhinitisSymptomsEnum.options.find(
                                (o) => o.value === v && v !== "none"
                              )?.header
                          )
                          ?.join?.(", ")}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
              <CheckInput
                checked={
                  !!signsAndSymptoms?.chronicRhinosinusitisSymptoms?.length &&
                  !signsAndSymptoms?.chronicRhinosinusitisSymptoms?.includes?.(
                    "none"
                  )
                }
                label={
                  <>
                    Duration of Symptoms: 12 Weeks or longer - Chronic
                    Rhinosinusitis
                    {signsAndSymptoms?.chronicRhinosinusitisSymptoms?.length ? (
                      <>
                        <br />
                        {signsAndSymptoms.chronicRhinosinusitisSymptoms
                          .map?.(
                            (v) =>
                              chronicRhinosinusitisSymptomsEnum.options.find(
                                (o) => o.value === v && v !== "none"
                              )?.header
                          )
                          ?.join?.(", ")}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
            </div>
            {signsAndSymptoms?.infectiveConfirmationType !== 0 && (
              <TealSubSection className="space-y-[0.0416667in]">
                {/* TODO: data for values? */}
                <DataField
                  label="Referral Reason"
                  value={"Infective Rhinitis"}
                />
                <DataField
                  label="Referral Type"
                  value={GetAlertConfirmation(
                    signsAndSymptoms?.infectiveConfirmationType
                  )}
                />
                {(signsAndSymptoms?.infectiveConfirmationType === 1 ||
                  signsAndSymptoms?.infectiveConfirmationType === 2) && (
                  <DataField
                    label="Explanation"
                    value={signsAndSymptoms?.infectiveExplaination}
                  />
                )}
                <DataField
                  label={`Pharmacist Clinical Decision to ${
                    signsAndSymptoms?.infectiveConfirmationType === 4
                      ? "End Service"
                      : "Continue with Service"
                  }`}
                  value={""}
                />
              </TealSubSection>
            )}
            <Divider />
          </div>
        )}

        {!endService?.endServiceObj?.infectiveEndService && (
          <div className="space-y-2">
            <H3>Differential Assessment</H3>
            <div className="space-y-4">
              <CheckInput
                checked={
                  !!differentialAssessment?.irritantRhinitis?.length &&
                  !differentialAssessment?.irritantRhinitis?.includes?.("none")
                }
                label={
                  <>
                    Irritant (Non-Allergic) Rhinitis
                    {!!differentialAssessment?.irritantRhinitis?.length &&
                    !differentialAssessment?.irritantRhinitis?.includes?.(
                      "none"
                    ) ? (
                      <>
                        <br />
                        Exposure to a physical or chemical irritant, Name if
                        Irritant if known: {""}
                        {differentialAssessment.irritantRhinitis
                          ?.map?.(
                            (v) =>
                              irritantRhinitisEnum.options.find(
                                (o) => o.value === v
                              )?.header
                          )
                          ?.join(", ")}
                      </>
                    ) : (
                      ""
                    )}
                  </>
                }
              />
              <CheckInput
                checked={
                  differentialAssessment?.occupationalRhinitisIndicator ===
                  "Yes"
                }
                label="Occupational Rhinitis"
              />
              <CheckInput
                checked={
                  !!differentialAssessment?.structuralOrMechanicalConditions
                    ?.length &&
                  !differentialAssessment?.structuralOrMechanicalConditions?.includes?.(
                    "none"
                  )
                }
                label="Structural or Mechanical Factors"
              />
              <CheckInput
                checked={
                  !!differentialAssessment?.systemicConditions?.length &&
                  !differentialAssessment?.systemicConditions?.includes?.(
                    "none"
                  )
                }
                label="Systemic Conditions"
              />
              <CheckInput
                checked={
                  (!differentialAssessment?.irritantRhinitis?.length ||
                    !!differentialAssessment?.irritantRhinitis?.includes?.(
                      "none"
                    )) &&
                  differentialAssessment?.occupationalRhinitisIndicator !==
                    "Yes" &&
                  (!differentialAssessment?.structuralOrMechanicalConditions
                    ?.length ||
                    !!differentialAssessment?.structuralOrMechanicalConditions?.includes?.(
                      "none"
                    )) &&
                  (!differentialAssessment?.systemicConditions?.length ||
                    !!differentialAssessment?.systemicConditions?.includes?.(
                      "none"
                    ))
                }
                label="None"
              />
            </div>
            {differentialAssessment?.differentialConfirmationType !== 0 && (
              <TealSubSection className="space-y-[0.0416667in]">
                {/* TODO: data for values? */}
                <DataField
                  label="Referral Reason"
                  value={"Differential Assessment"}
                />
                <DataField
                  label="Referral Type"
                  value={GetAlertConfirmation(
                    differentialAssessment?.differentialConfirmationType
                  )}
                />
                {(differentialAssessment?.differentialConfirmationType === 1 ||
                  differentialAssessment?.differentialConfirmationType ===
                    2) && (
                  <DataField
                    label="Explanation"
                    value={differentialAssessment?.differentialExplaination}
                  />
                )}
                <DataField
                  label={`Pharmacist Clinical Decision to ${
                    differentialAssessment?.differentialConfirmationType === 4
                      ? "End Service"
                      : "Continue with Service"
                  }`}
                  value={""}
                />
              </TealSubSection>
            )}
          </div>
        )}
      </div>
    </Section>
  );
};
